import React, { useState } from 'react'
import { api } from "../util/APIConfig"

function TuitionFeedbackModal({ isOpen, onClose, tuitionHours }) {
  const [step, setStep] = useState(1)
  const [rating, setRating] = useState(0)
  const [feedback, setFeedback] = useState('')

  const handleSubmit = async () => {
    try {
      await api.post('/User/Student/SubmitFeedback', { rating, feedback, tuitionHours, feedbackHour: tuitionHours })
      onClose()
    } catch (error) {
      console.error("Error submitting feedback:", error)
    }
  }

  const handleRatingSubmit = () => {
    if (rating > 0) {
      if(rating <= 8){
        setStep(2)
      }
      else if(rating >= 9)
      {
        handleSubmit()
        redirectToTrustpilot()
      }
    }
  }

  const redirectToTrustpilot = () => {
    window.open('https://uk.trustpilot.com/evaluate/www.uniadmissions.co.uk?stars=5', '_blank');
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg max-w-md w-full shadow-lg">
        {step === 1 ? (
          <CongratsAndRatingModal 
            tuitionHours={tuitionHours}
            rating={rating}
            setRating={setRating}
            onSubmit={handleRatingSubmit}
          />
        ) : (
          <FeedbackModal 
            rating={rating}
            feedback={feedback}
            setFeedback={setFeedback}
            onSubmit={handleSubmit}
          />
        )}
      </div>
    </div>
  )
}

function CongratsAndRatingModal({ tuitionHours, rating, setRating, onSubmit }) {
  return (
    <>
      <h2 className="text-2xl font-bold mb-4 text-center">
        Congratulations!
      </h2>
      <p className="mb-6 text-center">
        You've completed your {tuitionHours}th hour of tuition.
      </p>
      <p className="mb-6 text-center">
        We're dedicated to offering the highest quality of support and ensuring a positive experience in our programs. Your opinion matters greatly to us. We'd appreciate it if you could take a moment to rate your experience.

      </p>
      <h3 className="text-xl font-bold mb-4">
        Please Rate Your Experience
      </h3>
      <div className="flex justify-between mb-4">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((value) => (
          <button
            key={value}
            className={`px-3 py-1 rounded ${rating === value ? 'bg-blue-500 text-white' : 'bg-gray-200 hover:bg-gray-300'}`}
            onClick={() => setRating(value)}
          >
            {value}
          </button>
        ))}
      </div>
      <div className="flex justify-between text-sm mb-6">
        <span>Very Dissatisfied</span>
        <span>Very Satisfied</span>
      </div>
      <button
        className="w-full bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition duration-200"
        onClick={onSubmit}
      >
        Continue
      </button>
    </>
  )
}

function FeedbackModal({ rating, feedback, setFeedback, onSubmit }) {
  return (
    <>
      {rating <= 8 ? (
        <>
          <h2 className="text-xl font-bold mb-4">
            We'd Like to Hear More
          </h2>
          <p className="mb-4">
            We're sorry to hear that your experience within our programme hasn't met your expectations. Please help us by providing us with some details about your situation and a program manager will promptly reach out to you to address your concerns.
          </p>
          <textarea
            className="w-full h-24 border rounded p-2 focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4"
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            placeholder="Your feedback here..."
          ></textarea>
        </>
      ) : (
        <>
          <h2 className="text-xl font-bold mb-4">
            Thank You for Your Positive Feedback!
          </h2>
          <p className="mb-4">
            We're delighted to hear that your enrollment in our programme has been satisfactory for you. Please take a moment to share your experience with us <a href="https://uk.trustpilot.com/evaluate/www.uniadmissions.co.uk?stars=5" target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">here</a>, as short or as detailed as you want under a pseudonym or anonymously if you prefer. Thank you for your contribution.
          </p>
        </>
      )}
      <button
        className="w-full bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition duration-200"
        onClick={onSubmit}
      >
        Submit
      </button>
    </>
  )
}

export default TuitionFeedbackModal
